export const threeDegrees = {
  fontFamilyImport: [],
transitionMain: "all 300ms ease-in-out",

fieldTopSpacing: 20,
inputPaddingInline: 20,

inputHeight: 45,
inputWidth: '100',
inputWidthUnits: "%",

inputFontSize: 14,
inputFontFamily: '"Georgia", sans-serif',
inputColor: "#93979D",
inputBackgroundColor: "#fff",
inputFontWeight: 400,

inputBorderColor: "#707070",
inputBorderWidth: 1,
inputBorderRadius: 0,

inputHoverColor: "#93979D",
inputHoverBorderColor: "#707070",
inputHoverBackgroundColor: "#fff",

// **********************************
//  Select field
selectTopSpacing: 20,
selectPaddingInline: 20,

selectHeight: 45,
selectWidth: '100',
selectWidthUnits: "%",

selectFontSize: 14,
selectFontFamily: '"Georgia", sans-serif',
selectColor: "#93979D",
selectBackgroundColor: "#fff",
selectFontWeight: 400,

selectBorderColor: "#707070",
selectBorderWidth: 1,
selectBorderRadius: 0,

selectHoverColor: "#93979D",
selectHoverBorderColor: "#707070",
selectHoverBackgroundColor: "#fff",

addSelectBackgroundImage: false,
selectBackgroundImage: '',
selectBackgroundImagePositionRight: 10,
selectBackgroundImageSize: 20,

// **********************************
//  Text Area field
textAreaTopSpacing: 20,
textAreaPaddingInline: 20,

textAreaHeight: 45,
textAreaWidth: '100',
textAreaWidthUnits: "%",

textAreaFontSize: 14,
textAreaFontFamily: '"Georgia", sans-serif',
textAreaColor: "#93979D",
textAreaBackgroundColor: "#fff",
textAreaFontWeight: 400,

textAreaBorderColor: "#707070",
textAreaBorderWidth: 1,
textAreaBorderRadius: 0,

textAreaHoverColor: "#93979D",
textAreaHoverBorderColor: "#707070",
textAreaHoverBackgroundColor: "#fff",

// **********************************
//  placeholder
placeholderColor: "#93979D",
placeholderFontFamily: '"Georgia", sans-serif',
placeholderFontSize: 14,
placeholderFontWeight: 400,
placeholderHoverColor: "#93979D",

// **********************************
// script
addPlaceholders: false,
removeFieldLabels: false,

// **********************************
//  field label
fieldLabelBottomSpacing: 5,
fieldLabelPadding: 0,
fieldLabelFontSize: 14,
fieldLabelColor: "#93979D",
fieldLabelFontWeight: 400,
fieldLabelColorAsterisk: "#93979D",
fieldLabelAlignment: "column",
fieldLabelFontFamily: '"Georgia", sans-serif',

// **********************************
//  description
descriptionPaddingInline: 0,
descriptionColor: "#93979D",
descriptionFontSize: 14,
descriptionFontWeight: 400,
descriptionFontFamily: '"Georgia", sans-serif',
descriptionTopSpacing: 5,

// **********************************
// checkbox

addCheckbox: false,
checkedCheckboxContent: "",
checkboxInputSize: 15,
checkboxBorderWidth: 1,
checkboxBorderRadius: 0,
checkboxUncheckedBorderColor: "#707070",
checkboxUncheckedBackgroundColor: "#fff",
checkboxCheckedBackgroundColor: "#1eb0ec",
checkboxCheckedBorderColor: "#707070",
checkboxCheckedColor: "#fff",
checkboxAlignment: "none",
checkboxLabelFontFamily: '"Georgia", sans-serif',
checkboxLabelFontSize: 14,
checkboxLabelFontWeight: 400,
checkboxLabelColor: "#93979D",

// **********************************
// radio button

addRadioButton: false,
radioInputSize: 15,
radioBorderWidth: 1,
radioBorderRadius: 50,

radioUncheckedBorderColor: "#707070",
radioUncheckedBackgroundColor: "#fff",
radioCheckedBackgroundColor: "#1eb0ec",
radioCheckedBorderColor: "#707070",

radioAlignment: "none",

radioLabelFontFamily: '"Georgia", sans-serif',
radioLabelFontSize: 14,
radioLabelFontWeight: 400,
radioLabelColor: "#93979D",

// **********************************
// submit button

submitMarginTop: 34,
submitFontSize: 17,
submitFontFamily: "'Arial', sans-serif",
submitWidth: 195,
submitWidthUnits: "px",
submitHeight: 46,
submitBorderRadius: 0,
submitBorderWidth: 1,
submitBackground: "#FCB122",
submitColor: "#fff",
submitBorderColor: "#FCB122",
submitBackgroundHover: "#FCB122",
submitBorderColorHover: "#FCB122",
submitColorHover: "#fff",
submitTextAlign: "center",
submitButtonText: "Submit",
submitFontWeight: 700,
addBackgroundImage: false,
submitBackgroundImage: '',
submitBackgroundImagePositionRight: 10,
submitBackgroundImageSize: 20,
submitButtonAlign: "left",
};

